import { Pipe, PipeTransform } from '@angular/core';
import { BadgeColorEnum } from '../enum/badge-color.enum.model';

@Pipe({
    name: 'badgeColorStatus',
    standalone: false
})

export class BadgeColorStatusPipe implements PipeTransform {
  public transform(status: number, statusMapping: Array<{ status: number, badgeColor: BadgeColorEnum; }>): number {
    return statusMapping?.find(x => x.status === status)?.badgeColor ?? BadgeColorEnum.primary;
  }
}
